import styled from "@oui/system"
import * as React from "react"
import Box from "../Box"

type ToastWrapperProps = React.PropsWithChildren<{ y?: number; id?: string }>

const ToastWrapper_ = (props: ToastWrapperProps) => <Box {...props} />

const ToastWrapper = styled(ToastWrapper_)(
  ({ y = document.body.clientHeight }) => ({
    position: "absolute",
    // TODO: add speed to theme
    // https://jira.oci.oraclecorp.com/browse/OUI-409
    transition: "transform 250ms",
    transform: `translateY(${y}px)`,
    width: "100%",
    height: "auto",
    pointerEvents: "initial",
    top: 0,
    left: 0
  })
)

export default ToastWrapper
